// src/components/FunnelChart/FunnelChart.js
import React, { useState } from 'react';
import './FunnelChart.css';
import renderFunnel from './chartCard';
import renderFunnelold from './chartold';

import { useData } from '../../contexts/dataContext';
import { FiSettings, FiX } from 'react-icons/fi';

const FunnelChart = ({ filters, selectedCountry }) => {
  const title = 'Brand Funnel';
  const { sampleBrands,logoMap } = useData();
    const [isToggled, setIsToggled] = useState(true);

  // This function will be called when the button is clicked.
  const handleToggle = () => {
    // We use the setter function to flip the state from true to false, or vice versa.
    setIsToggled(!isToggled);
  };
  // State for settings
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [settings, setSettings] = useState({
    columns: 3,
    showLabels: true,
    showLogos: true,
    showPercentSymbol: true,
    showFrequency: true,
    showBase: true,
    animation: true
  });


  const getLogoComponent = (logoName) => {
    if (!settings.showLogos) return null;
    
    return logoMap[logoName] || <div style={{ 
      width: '30%', 
      height: '30px', 
      backgroundColor: '#f0f0f0', 
      borderRadius: '5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '12px',
      color: '#999'
    }}>{logoName || 'Logo'}</div>;
  };

  const actualBrands = sampleBrands;
  const numBrands = actualBrands.length;

  const maxBarWidth = 200;
  const barHeight = 35;
  const stageGap = 8;
  const barAreaWidth = 250;
  const labelWidth = 100;

  const handleSettingChange = (key, value) => {
    setSettings(prev => ({
      ...prev,
      [key]: value
    }));
  };


  return (
    <div className="funnel-chart-container">
      
      
      {/* Settings button */}
      <button 
        className="settings-button"
        onClick={() => setSettingsOpen(true)}
      >
        <FiSettings size={20} />
      </button>
      
      {/* Settings panel */}
      {settingsOpen && (
        <div className="settings-overlay">
          <div className="settings-panel">
            <div className="settings-header">
              <h2>Chart Settings</h2>
              <button 
                className="close-button"
                onClick={() => setSettingsOpen(false)}
              >
                <FiX size={20} />
              </button>
            </div>
            
            <div className="settings-content">
              <div className="setting-group">
                <label>Charts per row:</label>
                <select
                  value={settings.columns}
                  onChange={(e) => handleSettingChange('columns', parseInt(e.target.value))}
                >
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                  <option value={4}>4</option>
                  <option value={5}>5</option>
                </select>
              </div>
              
              <div className="setting-group">
                <label>
                  <input
                    type="checkbox"
                    checked={settings.showLabels}
                    onChange={(e) => handleSettingChange('showLabels', e.target.checked)}
                  />
                  Show Labels
                </label>
              </div>
              
              <div className="setting-group">
                <label>
                  <input
                    type="checkbox"
                    checked={settings.showLogos}
                    onChange={(e) => handleSettingChange('showLogos', e.target.checked)}
                  />
                  Show Logos
                </label>
              </div>
              
              <div className="setting-group">
                <label>
                  <input
                    type="checkbox"
                    checked={settings.showPercentSymbol}
                    onChange={(e) => handleSettingChange('showPercentSymbol', e.target.checked)}
                  />
                  Show Percent Symbol
                </label>
              </div>
              
              <div className="setting-group">
                <label>
                  <input
                    type="checkbox"
                    checked={settings.showFrequency}
                    onChange={(e) => handleSettingChange('showFrequency', e.target.checked)}
                  />
                  Show Frequency
                </label>
              </div>
              
              <div className="setting-group">
                <label>
                  <input
                    type="checkbox"
                    checked={settings.showBase}
                    onChange={(e) => handleSettingChange('showBase', e.target.checked)}
                  />
                  Show Base (Awareness)
                </label>
              </div>
              
              <div className="setting-group">
                <label>
                  <input
                    type="checkbox"
                    checked={settings.animation}
                    onChange={(e) => handleSettingChange('animation', e.target.checked)}
                  />
                  Enable Animations
                </label>
              </div>
              <div>
      <button 
        onClick={handleToggle}
        // Conditionally apply a CSS class based on the state.
        className={`toggle-button ${isToggled ? 'on' : 'off'}`}
      >
        {/* Conditionally render text based on the state. */}
        {isToggled ? 'Show cards' : 'Simple view'}
      </button>
    </div>
            </div>
          </div>
        </div>
      )}
      
      {/* <div className="charts-count">{numBrands} brands selected</div> */}
      
      <div
        className="funnels-grid"
        style={{
          gridTemplateColumns: `repeat(${settings.columns}, 1fr)`
        }}
      >
        {!isToggled && actualBrands.map((brand, index) => renderFunnel(brand, index,settings,getLogoComponent,labelWidth,maxBarWidth,barHeight))}
        {isToggled && actualBrands.map((brand, index) => renderFunnelold(brand, index,settings,getLogoComponent,labelWidth,maxBarWidth,barHeight,logoMap,stageGap,barAreaWidth))}
      </div>
    </div>
  );
};

export default FunnelChart;